/** CSS `aspect-ratio` from a domain `*_image` row (editor presets or free crop). */

const PRESETS = [
  { value: 1, css: '1 / 1' },
  { value: 16 / 9, css: '16 / 9' },
  { value: 4 / 3, css: '4 / 3' },
  { value: 3 / 4, css: '3 / 4' },
];

const SLASH_RATIO = /^\d+(\.\d+)?\s*\/\s*\d+(\.\d+)?$/;

export function isRoundCrop(image) {
  return image?.cropShape === 'round';
}

/**
 * Frame ratio for display. Round crops are always square.
 * `free` / missing → croppedAreaPixels, else 1:1.
 */
export function cssAspectRatioFromDomainImage(image) {
  if (isRoundCrop(image)) {
    return '1 / 1';
  }

  const raw = image?.aspectRatio;
  if (raw != null && raw !== '' && raw !== 'free') {
    const text = String(raw).trim();
    if (SLASH_RATIO.test(text)) {
      return text.replace(/\s+/g, ' ');
    }
    const numeric = Number(text);
    if (Number.isFinite(numeric) && numeric > 0) {
      const preset = PRESETS.find((item) => Math.abs(item.value - numeric) < 0.02);
      return preset ? preset.css : String(numeric);
    }
  }

  const area = image?.croppedAreaPixels;
  const width = Number(area?.width);
  const height = Number(area?.height);
  if (width > 0 && height > 0) {
    return `${width} / ${height}`;
  }

  return '1 / 1';
}
